var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1951_520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1578 0.0539665C5.41388 0.127751 0.00647256 5.65596 0.080836 12.4C0.154331 19.1432 5.68211 24.5509 12.4265 24.4769C14.9171 24.4498 17.3397 23.661 19.3703 22.217L26.3452 29.1905C27.1438 29.9787 28.4314 29.9705 29.2196 29.1709C29.9998 28.3801 29.9998 27.1078 29.2196 26.3158L22.2448 19.3423C26.1538 13.8468 24.8664 6.22194 19.3703 2.31265C17.2647 0.816698 14.7403 0.0254653 12.1578 0.0539665ZM12.011 2.16739C17.5804 2.01187 22.2219 6.39989 22.3774 11.9702C22.3799 12.0683 22.3821 12.1662 22.3821 12.2639C22.3841 17.8354 17.8687 22.3543 12.2977 22.3575C6.72595 22.3595 2.20685 17.8452 2.20424 12.2732C2.20424 12.2703 2.20424 12.2677 2.20424 12.2645C2.19802 6.79803 6.54626 2.32031 12.011 2.16739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5684 4.78262C10.1206 4.58513 10.7284 4.87188 10.9265 5.42411C11.1229 5.97229 10.8415 6.57689 10.2948 6.77914C7.98825 7.61855 6.45294 9.81097 6.45294 12.2651C6.45294 12.8522 5.97754 13.3276 5.39102 13.3276C4.80451 13.3276 4.3291 12.8522 4.3291 12.2651C4.32939 8.91789 6.42271 5.92744 9.5684 4.78262Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1951_520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMap);
export default __webpack_public_path__ + "static/media/search_map.2b498a6007e6fc5796cc6b69cd7f0932.svg";
export { ForwardRef as ReactComponent };